import(/* webpackMode: "eager", webpackExports: ["Paper"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Paper/Paper.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Text/Text.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
